<header>
    <mat-card-title class="text-lg-center text-xl-center mt-3">Payment Receipts</mat-card-title>
</header>

<div class="content">
    <div class="text-right mr-3">
        <button class="btn btn-primary mb-2" (click)="goBack()">
            <i class="fa fa-arrow-left mr-1"></i><span>Back</span>
        </button>
    </div>
    <div>
        <div appearance="outlined" class="list">
            <app-generic-table [rowData]="rowData" [enableCheckbox]="true" [allowMultiSelect]="true" [loader]="loader"
                [permission]="permissionsCheck" [sqPaginationConfig]="tablePaginationSettings"
                (getPagination)="getPageData($event)" (getActionTable)="getActions($event)" (getSorting)="sort($event)"
                [sqColumnDefinition]="columnDefinition" [length]="resultsLength"></app-generic-table>
        </div>
    </div>
</div>